<template>
  <d-modal
    size="lg"
    class="big-popup"
    @close="closePopup()">
    <d-modal-header>
      <d-modal-title>
        {{ $t('longRealizedOrdersPopup.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <d-checkbox
        v-if="userIsWorker"
        inline
        v-model="showAll"
        :disabled="loading"
        toggle
        toggle-small
        class="is-moved-to-top">
        {{ $t('order.showAllOrders') }}
      </d-checkbox>

      <table
        :class="{
          'table': true,
          'table-stripes': true,
          'is-loading': loading
        }">
        <thead>
          <tr>
            <td>{{ $t('longRealizedOrdersPopup.order') }}</td>
            <td v-if="showWorkerColumn">{{ $t('users.worker') }}</td>
            <td>{{ $t('longRealizedOrdersPopup.status') }}</td>
            <td>{{ $t('longRealizedOrdersPopup.created') }}</td>
            <td>{{ $t('longRealizedOrdersPopup.modified') }}</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(order, index) of extendedOrders"
            :key="'order-' + index">
            <td>
              <router-link
                :to="'/zamowienia/edycja/' + order.id"
                target="_blank">
                {{ order.order_name }}
              </router-link>
            </td>
            <td v-if="showWorkerColumn">
              {{ order.user_name }}
            </td>
            <td>
              <status-badge
                :status="order.status" />
            </td>
            <td>
              {{ order.created_at.replace('T', ' ').replace('.000000Z', '') }} ({{ order.created_days }} {{ $t('ui.days') }})
            </td>
            <td>
              {{ order.updated_at.replace('T', ' ').replace('.000000Z', '') }} ({{ order.updated_days }} {{ $t('ui.days') }})
            </td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
  </d-modal>
</template>

<script>
import StatusBadge from './../common/StatusBadge.vue';

export default {
  name: 'long-realized-orders-popup',
  props: [
    'orders',
    'popupShowAll',
  ],
  components: {
    'status-badge': StatusBadge
  },
  data () {
    return {
      showAll: !!this.popupShowAll,
      loading: false,
      ordersList: []
    };
  },
  computed: {
    userIsWorker () {
      return this.$store.getters.getUserType === 'worker';
    },
    showWorkerColumn () {
      return !this.userIsWorker || this.showAll;
    },
    extendedOrders () {
      let currentDate = new Date();

      return this.ordersList.map(order => {
        let createdDate = new Date(order.created_at);
        let updatedDate = new Date(order.updated_at);
        let createdTimeDiff = currentDate - createdDate;
        let updatedTimeDiff = currentDate - updatedDate;
        order.created_days = Math.floor(createdTimeDiff / (24 * 60 * 60 * 1000));
        order.updated_days = Math.floor(updatedTimeDiff / (24 * 60 * 60 * 1000));
        return order;
      }).reverse();
    }
  },
  watch: {
    showAll () {
      this.loadOrders();
    }
  },
  created () {
    this.ordersList = JSON.parse(JSON.stringify(this.orders));
  },
  methods: {
    loadOrders () {
      this.loading = true;

      this.$http.get('/dashboard/long-realized-orders' + (this.showAll ? '?show_all=true' : '')).then(response => {
        this.ordersList = (response.data && response.data.data) || [];
        this.loading = false;
      }).catch(error => {
        console.log(error);
        this.loading = false;
      });
    },
    closePopup () {
      this.$bus.$emit('dashboard-long-realized-orders-popup-close');
    }
  }
}
</script>

<style lang="scss" scoped>
.is-moved-to-top {
  left: auto;
  position: absolute;
  right: 60px;
  top: -43px;
}

table.is-loading {
  opacity: .33;
  pointer-events: none;
}
</style>
